export interface ScheduleItem {
  id: number;
  area: string;
  date: string; // "DD Month YYYY", or "TBA" when not yet confirmed
  time: string; // "HH:MM AM/PM", or "TBA"
  meetingPoint: string;
  contactPerson: string;
  contactPhone: string;
  providedItems: string[];
  lat: number;
  lng: number;
}

// Single source of truth for the 2026 clean-up schedule.
// Shared by the Home, Footer, and Campaigns pages so the dates never drift out of sync.
export const schedule: ScheduleItem[] = [
  {
    id: 1,
    area: "Moses Garoeb",
    date: "05 September 2026",
    time: "07:00 AM",
    meetingPoint: "Kapuka Nauyala",
    contactPerson: "Helena Ndengu",
    contactPhone: "+264 81 456 7890",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.5200,
    lng: 17.0900,
  },
  {
    id: 2,
    area: "Windhoek Rural",
    date: "12 September 2026",
    time: "07:00 AM",
    meetingPoint: "Mix Settlement",
    contactPerson: "Michael //Garoes",
    contactPhone: "+264 81 789 0123",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.4800,
    lng: 17.1500,
  },
  {
    id: 3,
    area: "John Pandeni",
    date: "19 September 2026",
    time: "07:00 AM",
    meetingPoint: "Omukaru Street",
    contactPerson: "Ruth Kauapirura",
    contactPhone: "+264 81 012 3456",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.5850,
    lng: 17.0950,
  },
  {
    id: 4,
    area: "Tobias Hainyeko",
    date: "17 October 2026",
    time: "07:00 AM",
    meetingPoint: "Babylon/Kilimanjaro",
    contactPerson: "Tomas Shilongo",
    contactPhone: "+264 81 901 2345",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.5750,
    lng: 17.0600,
  },
  {
    id: 5,
    area: "Samora Machel",
    date: "24 October 2026",
    time: "07:00 AM",
    meetingPoint: "Samora Machel Community Centre",
    contactPerson: "Grace Mwandingi",
    contactPhone: "+264 81 678 9012",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.5900,
    lng: 17.0700,
  },
  {
    id: 6,
    area: "Windhoek West",
    date: "07 November 2026",
    time: "07:00 AM",
    meetingPoint: "Windhoek West Community Hall, C/O Hage Geingob & Hosea Kutako",
    contactPerson: "Lydia Shilongo",
    contactPhone: "+264 81 890 1234",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.5550,
    lng: 17.0300,
  },
  {
    id: 7,
    area: "Katutura Central",
    date: "TBA",
    time: "TBA",
    meetingPoint: "To be announced",
    contactPerson: "John Kamati",
    contactPhone: "+264 81 123 4567",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.5609,
    lng: 17.0658,
  },
  {
    id: 8,
    area: "Katutura East",
    date: "TBA",
    time: "TBA",
    meetingPoint: "To be announced",
    contactPerson: "Maria Shikongo",
    contactPhone: "+264 81 234 5678",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.5450,
    lng: 17.0800,
  },
  {
    id: 9,
    area: "Khomasdal",
    date: "TBA",
    time: "TBA",
    meetingPoint: "To be announced",
    contactPerson: "Petrus Nangoloh",
    contactPhone: "+264 81 345 6789",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.5350,
    lng: 17.0450,
  },
  {
    id: 10,
    area: "Windhoek East",
    date: "TBA",
    time: "TBA",
    meetingPoint: "To be announced",
    contactPerson: "David Namene",
    contactPhone: "+264 81 567 8901",
    providedItems: ["PPE (Gloves & Masks)", "Reflective Vests", "Trash Bags", "Refreshments", "Sun Protection"],
    lat: -22.5700,
    lng: 17.0850,
  },
];

/** Parses this schedule's "DD Month YYYY" date strings into a Date at end-of-day. "TBA" parses to null. */
export const parseScheduleDate = (date: string): Date | null => {
  if (date.trim().toUpperCase() === "TBA") return null;
  return new Date(`${date} 23:59:59`);
};

/** True once the event's date has passed relative to now. A TBA date is never considered past. */
export const isPastEvent = (date: string): boolean => {
  const parsed = parseScheduleDate(date);
  return parsed !== null && parsed.getTime() < Date.now();
};

/** Upcoming (including TBA) events only, in schedule order. */
export const upcomingSchedule = (): ScheduleItem[] => schedule.filter((s) => !isPastEvent(s.date));
